import { FC } from "react"

import { Table } from "@/components/_Shared/Table"
import { Resource } from "@/constants/permission"

import { authorityRegisterLogsColumns } from "./AuthorityRegisterLogsColumns"

import { useAuthorityRegisterLogsQuery } from "@/hook/Authorities/useAuthoritiesPageQuery"
import { useTable } from "@/hook/useTable"

import { AUTHORITY_REGISTER_LOGS_KEY } from "@/types/IAuthorities"

import { getInitialColumns } from "@/utils/getInitialColumns"


const AuthorityRegisterLogsPage: FC = () => {
  const { columns, pagination, order, filter } = useTable({
    initialColumns: getInitialColumns(authorityRegisterLogsColumns, AUTHORITY_REGISTER_LOGS_KEY),
    key: AUTHORITY_REGISTER_LOGS_KEY
  })

  const { data, isLoading } = useAuthorityRegisterLogsQuery({
    Page: pagination.page,
    PageSize: pagination.pageSize,
    Filter: filter.filter,
    OrderBy: order.orderBy
  })

  return (
    <>
      <Table
        tableTitle="Логи регистрации доверенностей"
        dataSource={data?.response.data}
        columns={columns.data}
        rowKey="id"
        isLoading={isLoading}
        onUpdateColumns={columns.onColumnChange}
        pagination={{
          currentPage: pagination.page,
          pageSize: pagination.pageSize,
          total: data?.response.count,
          onPageChange: pagination.onPageChange,
          onPageSizeChange: pagination.onPageSizeChange
        }}
        onSorterChange={order.setOrderBy}
        permission={{
          resource: Resource.AuthoritiesLogs
        }}
      />
    </>
  )
}

export default AuthorityRegisterLogsPage